/**
 * Change first letter for a string
 *
 * @param {string} str String to change
 * @param {boolean} capitalize If capitalize change first letter to uppercase
 * @returns {string} Modified string
 */
function firstLetter(str, capitalize = true) {
  let output = str
    .charAt(0)[capitalize
      ? 'toUpperCase'
      : 'toLowerCase']();
  output += str
    .slice(1);

  return output;
}

/**
 * Parse string values to JavaScript data types
 *
 * @param {string} str
 * @returns {any}
 */
function parseValue(str) {
  let val = str.trim();

  if (val === 'true') {
    val = true;
  } else if (val === 'false') {
    val = false;
  }

  if (String(parseFloat(val)) === val) {
    val = parseFloat(val) || val;
  }

  return val;
}

/**
 * Pupulate string with values in object
 *
 * @param {string} str String to populate
 * @param {object} values Data to populate string
 * @param {string} prefix Prefix for replacement values
 * @returns {string} Populate string
 */
function populate(str, values = {}, prefix = ':') {
  let output = str;

  for (const [k, v] of Object.entries(values)) {
    const key = `${prefix}${k}`;

    output = (v !== null && typeof v === 'object')
      ? populate(output, v, `${key}.`)
      : replaceAll(output, key, v);
  }

  return output;
}

/**
 *
 * @param {*} str
 * @param {*} search
 * @param {*} replacement
 * @returns
 */
function replaceAll(str, search, replacement) {
  return str
    .split(search)
    .join(replacement);
}

/**
 * Codifica a base64 de forma segura, aceptando cualquier carácter Unicode.
 *
 * `btoa` lanza InvalidCharacterError con cualquier code unit > U+00FF, y eso
 * incluye cosas que aparecen escribiendo normal: el guion largo que macOS
 * genera al teclear "--", el apóstrofo curvo, o cualquier emoji/CJK pegado.
 * Pasar antes por encodeURIComponent deja la cadena en Latin1.
 *
 * @param {string} str Cadena a codificar
 * @returns {string} Cadena en base64
 */
function toBase64Utf8(str) {
  return btoa(unescape(encodeURIComponent(String(str))));
}

/**
 * Decodifica una cadena base64 producida por toBase64Utf8(). Devuelve '' si la
 * entrada está corrupta (base64 inválido) en lugar de lanzar, para que el
 * llamador pueda caer a un destino seguro.
 *
 * @param {string} str Cadena en base64
 * @returns {string} Cadena decodificada, o '' si no es base64 válido
 */
function fromBase64Utf8(str) {
  try {
    return decodeURIComponent(escape(atob(String(str))));
  } catch (e) {
    return '';
  }
}

/**
 * Valida un destino de redirección para evitar open redirects.
 *
 * Sólo se aceptan rutas internas de esta SPA: deben empezar con una sola "/"
 * y no con "//" ni "/\" (que el navegador interpreta como protocol-relative y
 * mandan a otro host). Cualquier URL absoluta (http:, https:, //evil.com) o
 * valor vacío cae al fallback.
 *
 * @param {string} path Ruta candidata (ya decodificada)
 * @param {string} fallback Destino seguro si `path` no es válido
 * @returns {string} Una ruta interna segura
 */
function safeRedirectPath(path, fallback = '/') {
  const value = typeof path === 'string' ? path.trim() : '';

  if (!value.startsWith('/')) return fallback;
  // "//host" y "/\host" son tratados como protocol-relative por el navegador.
  if (value.startsWith('//') || value.startsWith('/\\')) return fallback;

  return value;
}

export {
  firstLetter,
  fromBase64Utf8,
  parseValue,
  populate,
  replaceAll,
  safeRedirectPath,
  toBase64Utf8,
};

